export enum JobType{
    CreateTenant = 1,
    IcwAktar = 2
}